import type { RequestParameters } from "#shopware";

type HandlePaymentExtensions = Omit<
  RequestParameters<"handlePaymentMethod">,
  "errorUrl" | "finishUrl" | "orderId"
>;
export const useHandlePaymentExtensions = () =>
  useState<HandlePaymentExtensions>("handlePaymentExtensions", () => ({}));
